import z from 'zod';

// ---------------------------------------------------------------------------
// Feedback schema (matches Feedback interface)
// ---------------------------------------------------------------------------

export const zFeedback = z.object({
  id: z.uuid(),
  user_id: z.int(),
  handled: z.boolean(),
  handled_user_id: z.int().nullable(),
  message: z.string(),
  proto_list_id: z.uuid().nullable(),
  proto_node_id: z.uuid().nullable(),
  instance_list_id: z.uuid().nullable(),
  instance_node_id: z.uuid().nullable(),
  timestamp: z.date(),
  updated: z.date(),
});

// ---------------------------------------------------------------------------
// Create payload schema
// ---------------------------------------------------------------------------

export const zCreateFeedbackPayload = z.object({
  message: z.string().min(1),
  user_id: z.int(),
  proto_list_id: z.uuid(),
  proto_node_id: z.uuid(),
  instance_list_id: z.uuid(),
  instance_node_id: z.uuid(),
});
